import React from "react";
import { Phone, Mail } from "lucide-react";
import { EMAIL } from "../../lib/content";

export const ContactInfo = ({ t }) => (
  <>
    <a
      href={`tel:${t.phone.tel}`}
      data-testid="contact-phone-block"
      className="mt-10 group flex items-center gap-5 bg-brand-accent hover:bg-[color:var(--color-accent-hover)] transition-colors p-5 md:p-6"
    >
      <span className="w-12 h-12 flex items-center justify-center bg-white/15 flex-shrink-0">
        <Phone className="w-6 h-6 text-white" strokeWidth={2.5} />
      </span>
      <div>
        <div className="font-display text-[11px] font-bold tracking-widest uppercase text-white/85">
          {t.contact.phoneLabel}
        </div>
        <div className="font-display text-2xl md:text-3xl font-black tracking-tight text-white mt-0.5">
          {t.phone.display}
        </div>
      </div>
    </a>

    <a
      href={`mailto:${EMAIL}`}
      data-testid="contact-email-block"
      className="mt-3 group flex items-center gap-5 border border-white/15 hover:border-brand-accent hover:bg-white/5 transition-colors p-5 md:p-6"
    >
      <span className="w-12 h-12 flex items-center justify-center bg-brand-accent/20 flex-shrink-0">
        <Mail className="w-6 h-6 text-brand-accent" strokeWidth={2.5} />
      </span>
      <div className="min-w-0">
        <div className="font-display text-[11px] font-bold tracking-widest uppercase text-white/85">
          {t.contact.emailLabel}
        </div>
        <div className="font-display text-sm sm:text-base lg:text-lg font-black tracking-tight text-white mt-0.5 break-all">
          {EMAIL}
        </div>
      </div>
    </a>
  </>
);
